import { useNavigate } from "react-router-dom";
import { FetchedReportData } from "../../../types";
// import { getFileNameTimeStamp } from "../../utils/dateUtils";
import ReportViewCard from "../ReportViewCard";
import { FaX } from "react-icons/fa6";
import { PDFDownloadLink } from "@react-pdf/renderer";
import UserReportPDFTemplate from "../../../utils/UserReportPDFTemplate";

const UserViewReport = ({ report }: { report?: FetchedReportData }) => {
  const navigate = useNavigate();

  if (!report) {
    return null;
  }

  const goHome = () => {
    navigate("/");
  };

  return (
    <section
      id="report-content"
      className="relative bg-white dark:bg-white flex flex-col flex-grow gap-8 justify-center items-center h-full text-white text-center py-0 pt-[70px] md:py-10"
    >
      <FaX
        onClick={goHome}
        className="flex md:hidden absolute top-6 right-6 md:static text-black h-6 w-6"
      />
      <ReportViewCard
        report={report}
        className="w-full md:w-[761px] h-full md:h-[calc(100%-80px)] rounded-0 md:rounded-2xl border-0 md:border md:border-gray-7"
        isUser
      />

      <div className="flex items-center gap-6 h-0 md:h-auto">
        <button
          onClick={goHome}
          className="hidden md:flex text-[18px] leading-[22px] font-extrabold border-2 border-gray-7 bg-transparent text-gray-7 py-[14px] px-[92px] rounded-[24px]"
        >
          Back to Home
        </button>

        <PDFDownloadLink
          document={<UserReportPDFTemplate report={report} />}
          fileName={`Report-form-Unspoken_${new Date().toISOString()}.pdf`}
          className="font-extrabold absolute bottom-6 left-[calc(50%-73px)] md:static text-base md:text-lg leading-5 md:leading-[22px] bg-danger md:bg-gray-7 text-white py-[11px] md:py-[15px] px-[21.5px] md:px-[92px] rounded-3xl no-underline"
        >
          {/* {({ loading }) => (loading ? "Generating PDF..." : "Export to PDF")} */}
          Export to PDF
        </PDFDownloadLink>
      </div>
    </section>
  );
};

export default UserViewReport;
